export const DAYS = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const DEFAULT_COL_WIDTH = 80;
export const MIN_COL_WIDTH = 70;

export const formatHour = (h) => {
  if (h === undefined || h === null) return "--";
  const ampm = h >= 12 ? "PM" : "AM";
  const hour = h % 12 || 12;
  return `${hour}${ampm}`;
};

export const formatRange = (s, e) => `${formatHour(s)} – ${formatHour(e)}`;

export const isToday = (date) => {
  const t = new Date();
  return (
    t.getDate() === date.getDate() &&
    t.getMonth() === date.getMonth() &&
    t.getFullYear() === date.getFullYear()
  );
};

export const getMonthDates = (year, month) => {
  const today = new Date();
  const start =
    today.getFullYear() === year && today.getMonth() === month
      ? new Date(year, month, today.getDate())
      : new Date(year, month, 1);

  const d = new Date(start);
  const res = [];
  while (d.getMonth() === month) {
    res.push(new Date(d));
    d.setDate(d.getDate() + 1);
  }
  return res;
};

export const getDaySlot = (staff, day) =>
  staff.timeslot?.find((t) => t.day === day);

export const makeDateKey = (date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};
